var map = {
	"./40.svg": 8483,
	"./41.svg": 2915,
	"./43.svg": 4405,
	"./44.svg": 1558,
	"./45.svg": 185,
	"./46.svg": 147,
	"./47.svg": 8372,
	"./48.svg": 6769,
	"./49.svg": 3129,
	"./50.svg": 3996,
	"./51.svg": 8810,
	"./52.svg": 9944,
	"./53.svg": 1902,
	"./54.svg": 1693,
	"./55.svg": 5009,
	"./56.svg": 1227,
	"./57.svg": 7058,
	"./58.svg": 2069,
	"./59.svg": 8179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6704;